export * from './policyServicing-app-settings.config'